import { AlertContext } from 'contexts/AlertContext/AlertContext';
import { useContext } from 'react';

const useAlert = () => {
  return useContext(AlertContext);
};

export default useAlert;
